const skeleton = `<div class="sk-container">
  <style>
    .sk-transparent {
    color: transparent !important;
  }
.sk-text-16-6667-895 {
    background-image: linear-gradient(transparent 16.6667%, #EEEEEE 0%, #EEEEEE 83.3333%, transparent 0%) !important;
    background-size: 100% 35.1563rpx;
    position: relative !important;
  }
.sk-text {
    background-origin: content-box !important;
    background-clip: content-box !important;
    background-color: transparent !important;
    color: transparent !important;
    background-repeat: repeat-y !important;
  }
.sk-opacity {
    opacity: 0 !important;
  }
.sk-text-11-5385-740 {
    background-image: linear-gradient(transparent 11.5385%, #EEEEEE 0%, #EEEEEE 88.4615%, transparent 0%) !important;
    background-size: 100% 42.6563rpx;
    position: relative !important;
  }
.sk-text-0-0000-896 {
    background-image: linear-gradient(transparent 0.0000%, #EEEEEE 0%, #EEEEEE 100.0000%, transparent 0%) !important;
    background-size: 100% 30.4688rpx;
    position: relative !important;
  }
.sk-text-0-0000-650 {
    background-image: linear-gradient(transparent 0.0000%, #EEEEEE 0%, #EEEEEE 100.0000%, transparent 0%) !important;
    background-size: 100% 30.4688rpx;
    position: relative !important;
  }
.sk-image {
    background: #EFEFEF !important;
  }
.sk-container {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 100;
    background-color: #ffffff;
  }
    .sk-container .navBar {
      position: relative !important;
    }
    .sk-container .navBar .tit {
      position: absolute;
      display: block;
      width: 50%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 20px;
    }
      .m-t {
  margin-top: 8px;
}
.sk-container .home-container {
  min-height: 101vh;
}
/* 头部 轮播图 */
.sk-container .carousel-section {
  position: relative;
  padding-top: 10px;
}
 .sk-container .carousel-section  .titleNview-placing {
    height: var(--status-bar-height);
    padding-top: 44px;
    box-sizing: content-box;
  }

.sk-container .carousel-section   .titleNview-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 213px;
    transition: 0.4s;
  }

.sk-container .carousel {
  width: 100%;
  height: 175px;
}

.sk-container .carousel  .carousel-item {
    width: 100%;
    height: 100%;
    padding: 0 14px;
    overflow: hidden;
  }

.sk-container .carousel   uni-image {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }

.sk-container .swiper-dots {
  display: flex;
  position: absolute;
  left: 30px;
  bottom: 7.5px;
  width: 36px;
  height: 18px;
  background-image: url(data:image/png;base64,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);
  background-size: 100% 100%;
}
.sk-container .swiper-dots   .num {
    width: 18px;
    height: 18px;
    border-radius: 50px;
    font-size: 12px;
    color: #fff;
    text-align: center;
    line-height: 18px;
  }

 .sk-container .swiper-dots  .sign {
    position: absolute;
    top: 0;
    left: 50%;
    line-height: 18px;
    font-size: 6px;
    color: #fff;
    transform: translateX(-50%);
  }
.f-header {
  display: flex;
  align-items: center;
  height: 70px;
  padding: 3px 15px 4px;
  background: #fff; }
  .f-header uni-image {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    margin-right: 10px; }
  .f-header .tit-box {
    flex: 1;
    display: flex;
    flex-direction: column; }
  .f-header .tit {
    line-height: 1.3; }
  .f-header .timer {
    display: inline-block;
    width: 20px;
    height: 18px;
    text-align: center;
    line-height: 18px;
    margin-right: 7px;
    color: #fff;
    border-radius: 2px;
    background: rgba(0, 0, 0, 0.8); }

/* 分类推荐楼层 */
.hot-floor {
  width: 100%;
  overflow: hidden;
  margin-bottom: 10px; }
  .hot-floor .floor-img-box {
    width: 100%;
    height: 160px;
    position: relative; }
    .hot-floor .floor-img-box:after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(rgba(255, 255, 255, 0.06) 30%, #f8f8f8); }
  .hot-floor .floor-img {
    width: 100%;
    height: 100%; }
  .hot-floor .floor-list {
    white-space: nowrap;
    padding: 10px;
    padding-right: 25px;
    border-radius: 3px;
    margin-top: -70px;
    margin-left: 15px;
    background: #fff;
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);
    position: relative;
    z-index: 1; }
  .hot-floor .scoll-wrapper {
    display: flex;
    align-items: flex-start; }
  .hot-floor .floor-item {
    width: 80px;
    margin-right: 10px;
    line-height: 1.8; }
    .hot-floor .floor-item uni-image {
      width: 90px;
      height: 90px;
      border-radius: 3px; }
  .hot-floor .more {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    flex-shrink: 0;
    width: 90px;
    height: 90px;
    border-radius: 3px;
    background: #f3f3f3; }
    .hot-floor .more text:first-child {
      margin-bottom: 2px; }

/* 猜你喜欢 */
.guess-section {
  display: flex;
  flex-wrap: wrap;
  padding: 0 15px;
  background: #fff; }
  .guess-section .guess-item {
    display: flex;
    flex-direction: column;
    width: 48%;
    padding-bottom: 20px; }
    .guess-section .guess-item:nth-child(2n + 1) {
      margin-right: 4%; }
  .guess-section .image-wrapper {
    width: 100%;
    height: 165px;
    border-radius: 3px;
    overflow: hidden; }
    .guess-section .image-wrapper uni-image {
      width: 100%;
      height: 100%;
      opacity: 1; }
  .guess-section .image-wrapper-brand {
    width: 100%;
    height: 75px;
    border-radius: 3px;
    overflow: hidden; }
    .guess-section .image-wrapper-brand uni-image {
      width: 100%;
      height: 100%;
      opacity: 1; }
  .guess-section .title {
    line-height: 40px; }
  .guess-section .title2 {
    line-height: 20px; }
  .guess-section .price {
    line-height: 1; }

  </style>
  <div class="container">
    <uni-view class="navBar" status-bar="true" fixed="true"><uni-view data-v-0957edea="" class="status_bar" style="height: var(--status-bar-height); width: 100%"></uni-view><uni-view data-v-4afea59e="" data-v-0957edea="" class="uni-navbar uni-nvue-fixed" status-bar="true"><uni-view data-v-4afea59e="" class="uni-navbar__placeholder"><uni-view data-v-4afea59e="" class="uni-navbar__placeholder-view" style="height: 44px"><uni-text class="tit sk-transparent sk-text-11-5385-740 sk-text"></uni-text></uni-view></uni-view></uni-view></uni-view>
      <uni-view class="home-container">
        <uni-view class="carousel-section">
          <uni-swiper autoplay="false" circular="true" class="carousel sk-image" data-event-opts="change,swiperChange,$event" current="0"></uni-swiper>
        </uni-view>
        <uni-view class="f-header m-t">
          <uni-image class="sk-image"></uni-image>
          <uni-view class="tit-box">
            <uni-text class="tit sk-transparent sk-text-11-5385-740 sk-text">sss</uni-text>
          </uni-view>
        </uni-view>
        <uni-view class="guess-section">
          <uni-view class="guess-item" data-event-opts="tap,navToDetailPage,$0,recommendProductList,,0">
            <uni-view class="image-wrapper">
              <uni-image  mode="aspectFill" class="sk-image"></uni-image>
            </uni-view>
            <uni-text class="title clamp"></uni-text>
            <uni-text class="title2 clamp"></uni-text>
            <uni-text class="price sk-transparent sk-text-0-0000-896 sk-text">NaN</uni-text>
          </uni-view>
          <uni-view class="guess-item" data-event-opts="tap,navToDetailPage,$0,recommendProductList,,1">
            <uni-view class="image-wrapper">
              <uni-image  mode="aspectFill" class="sk-image"></uni-image>
            </uni-view>
            <uni-text class="title clamp"></uni-text>
            <uni-text class="title2 clamp"></uni-text>
            <uni-text class="price sk-transparent sk-text-0-0000-650 sk-text">NaN</uni-text>
          </uni-view>
          <uni-view class="guess-item" data-event-opts="tap,navToDetailPage,$0,recommendProductList,,2">
            <uni-view class="image-wrapper">
              <uni-image mode="aspectFill" class="sk-image"></uni-image>
            </uni-view>
             <uni-text class="title clamp"></uni-text>
            <uni-text class="title2 clamp"></uni-text>
            <uni-text class="price sk-transparent sk-text-0-0000-896 sk-text">NaN</uni-text>
          </uni-view>
        </uni-view>
      </uni-view>
  </div>
</div>
`;
export const showSkeleton = () => {
  const hasLoading = document.getElementById("sk-app-loading");
  const skLoading = document.createElement("div");
  skLoading.setAttribute("id", "sk-app-loading");
  skLoading.innerHTML = skeleton;
  if (!hasLoading) {
    document.body.appendChild(skLoading);
  }
};

export const hideSkeleton = () => {
  const skLoading = document.getElementById("sk-app-loading");
  if (skLoading) {
    document.body.removeChild(skLoading);
  }
};
